import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Filiais() {
  const [selectedFilial, setSelectedFilial] = useState<string | null>(null);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const navigate = useNavigate();

  const filiais = [
    {
      id: 'rio-maior',
      nome: 'Igreja Filial Rio Maior',
      pastores: 'Pastores Arão e Juliane',
      endereco: 'Rio Maior, Portugal',
      mapsUrl: 'https://maps.app.goo.gl/a8J6jbZLTbJpcKHJ7?g_st=awb',
      foto: 'https://static.readdy.ai/image/8fbfc975813ef59021c9f16b313e86f9/f11413561c987601736b5e5921365392.jpeg',
      email: 'contato.riomaior@missaoeuropa.pt',
      telefone: '+351 243 123 456',
      whatsapp: '+351 912 345 678',
      facebook: '',
      instagram: '',
      youtube: '',
      horarios: [
        { dia: 'Domingo', horario: '19:00 - Culto da Família' },
        { dia: 'Quarta', horario: '20:00 - Culto da Vitória' },
        { dia: 'Sexta', horario: '20:00 - Culto de Estudo Bíblico' }
      ],
      descricao: 'Uma igreja comprometida com a evangelização e o crescimento espiritual da comunidade de Rio Maior.',
      versiculo: '"Portanto ide, fazei discípulos de todas as nações, batizando-os em nome do Pai, e do Filho, e do Espírito Santo." - Mateus 28:19'
    }
  ];

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/login');
  };

  const openMaps = (url: string) => {
    window.open(url, '_blank');
  };

  const openModal = (filialId: string) => {
    setSelectedFilial(filialId);
  };

  const closeModal = () => {
    setSelectedFilial(null);
  };

  const openImageModal = (imageUrl: string) => {
    setSelectedImage(imageUrl);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };

  const selectedFilialData = filiais.find(f => f.id === selectedFilial);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-400 via-purple-500 to-pink-500">
      {/* Header */}
      <header className="bg-white/95 backdrop-blur-sm shadow-xl border-b-4 border-gradient-to-r from-blue-600 to-purple-600">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <img 
                src="https://static.readdy.ai/image/8fbfc975813ef59021c9f16b313e86f9/f5810bc36c96b4c4a03e9a9aa341e507.png"
                alt="Assembleia de Deus - Missão Europa"
                className="w-20 h-20 sm:w-24 sm:h-24 lg:w-32 lg:h-32 object-contain shadow-2xl rounded-2xl border-4 border-indigo-200"
              />
              <div className="text-center flex-1">
                <h1 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent whitespace-nowrap">
                  <span style={{ fontFamily: '"Agnes", serif' }}>IGREJA AD MISSÃO EUROPA CHURCH</span>
                </h1>
                <p className="text-sm text-gray-600">Church Portugal</p>
              </div>
            </div>
            
            <nav className="flex items-center space-x-6">
              <button 
                onClick={() => navigate('/home')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-home-line"></i>
                <span>Início</span>
              </button>
              <button 
                onClick={() => navigate('/bible')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-book-line"></i>
                <span>Bíblia</span>
              </button>
              <button 
                onClick={() => navigate('/characters')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-user-star-line"></i>
                <span>Personagens</span>
              </button>
              <button 
                onClick={() => navigate('/radio')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-radio-line"></i>
                <span>Rádio</span>
              </button>
              <button 
                onClick={() => navigate('/kids')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-bear-smile-line"></i>
                <span>Crianças</span>
              </button>
              <button 
                onClick={() => navigate('/devotionals')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-heart-line"></i>
                <span>Devocionais</span>
              </button>
              <button 
                onClick={() => navigate('/studies')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-graduation-cap-line"></i>
                <span>Estudos</span>
              </button>
              <button 
                onClick={() => navigate('/prayer-requests')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-hands-line"></i>
                <span>Oração</span>
              </button>
              <button 
                onClick={() => navigate('/gallery')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-gallery-line"></i>
                <span>Mural</span>
              </button>
              <button 
                onClick={() => navigate('/location')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-map-pin-line"></i>
                <span>Localização</span>
              </button>
              <button 
                onClick={() => navigate('/filiais')}
                className="flex items-center space-x-2 px-4 py-2 text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-building-2-line"></i>
                <span>Filiais</span>
              </button>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <div className="relative h-96 bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 overflow-hidden">
        <div className="absolute inset-0 bg-black/30"></div>
        <img 
          src="https://public.readdy.ai/ai/img_res/d1836970f20fd8298511c19f5d2acd82.jpg"
          alt="Igrejas Filiais"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white max-w-4xl px-6">
            <h2 className="text-5xl font-bold mb-4">Nossas Igrejas Filiais</h2>
            <p className="text-xl mb-4 opacity-90">
              Expandindo o Reino de Deus através de igrejas locais
            </p>
            <div className="bg-black/20 backdrop-blur-sm rounded-lg p-6 mt-6">
              <p className="text-lg italic font-medium">
                "Portanto ide, fazei discípulos de todas as nações, batizando-os em nome do Pai, e do Filho, e do Espírito Santo."
              </p>
              <p className="text-sm mt-2 opacity-80">- Mateus 28:19</p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        {/* Introdução */}
        <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8 border border-white/20 mb-12">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-4">
              Família de Igrejas Unidas
            </h3>
            <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
              Cada igreja filial é um centro de evangelização e discipulado, comprometida em ganhar almas para Jesus Cristo. 
              Nosso coração arde pelo crescimento do Reino de Deus em cada cidade e comunidade.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center p-6 bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-add-line text-2xl text-white"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-800 mb-2">Ganhar Almas</h4>
              <p className="text-gray-600">Evangelização ativa e amor pelas pessoas perdidas</p>
            </div>

            <div className="text-center p-6 bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl">
              <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-group-line text-2xl text-white"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-800 mb-2">Fazer Discípulos</h4>
              <p className="text-gray-600">Formação e crescimento espiritual contínuo</p>
            </div>

            <div className="text-center p-6 bg-gradient-to-r from-pink-50 to-red-50 rounded-xl">
              <div className="w-16 h-16 bg-gradient-to-r from-pink-500 to-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-earth-line text-2xl text-white"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-800 mb-2">Expandir o Reino</h4>
              <p className="text-gray-600">Plantação de novas igrejas e ministérios</p>
            </div>
          </div>
        </div>

        {/* Lista de Filiais */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {filiais.map((filial) => (
            <div key={filial.id} className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl overflow-hidden border border-white/20">
              {/* Foto dos Pastores */}
              <div className="relative h-64 overflow-hidden cursor-pointer" onClick={() => openImageModal(filial.foto)}>
                <img 
                  src={filial.foto}
                  alt={`Pastores ${filial.pastores}`}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 text-white">
                  <h4 className="text-xl font-bold">{filial.pastores}</h4>
                  <p className="text-sm opacity-90">Pastores Locais</p>
                </div>
                <div className="absolute top-4 right-4 bg-black/50 rounded-full p-2">
                  <i className="ri-zoom-in-line text-white text-lg"></i>
                </div>
              </div>

              {/* Informações da Igreja */}
              <div className="p-6">
                <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-4">
                  {filial.nome}
                </h3>

                {/* Versículo */}
                <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg p-4 mb-6">
                  <p className="text-gray-700 italic text-center font-medium">
                    {filial.versiculo}
                  </p>
                </div>

                {/* Contatos */}
                <div className="space-y-4 mb-6">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center">
                      <i className="ri-map-pin-line text-white"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800">Endereço</p>
                      <p className="text-gray-600">{filial.endereco}</p>
                    </div>
                  </div>

                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center">
                      <i className="ri-mail-line text-white"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800">Email</p>
                      <p className="text-gray-600">{filial.email}</p>
                    </div>
                  </div>

                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-gradient-to-r from-pink-500 to-red-500 rounded-full flex items-center justify-center">
                      <i className="ri-phone-line text-white"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800">Telefone</p>
                      <p className="text-gray-600">{filial.telefone}</p>
                    </div>
                  </div>
                </div>

                {/* Botões de Ação */}
                <div className="grid grid-cols-2 gap-4">
                  <button 
                    onClick={() => openMaps(filial.mapsUrl)}
                    className="bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-200 shadow-lg flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-navigation-line"></i>
                    <span>Como Chegar</span>
                  </button>

                  <button 
                    onClick={() => openModal(filial.id)}
                    className="bg-gradient-to-r from-purple-600 to-pink-600 text-white py-3 rounded-lg font-semibold hover:from-purple-700 hover:to-pink-700 transition-all duration-200 shadow-lg flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-information-line"></i>
                    <span>Mais Info</span>
                  </button>
                </div>
              </div>
            </div>
          ))}

          {/* Card para Adicionar Nova Filial */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl border border-white/20 border-dashed">
            <div className="p-8 text-center">
              <div className="w-20 h-20 bg-gradient-to-r from-gray-300 to-gray-400 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-add-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-700 mb-4">Nova Igreja Filial</h3>
              <p className="text-gray-600 mb-6">
                Em breve mais igrejas filiais serão adicionadas conforme o crescimento da obra.
              </p>
              <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-lg p-4">
                <p className="text-sm text-gray-600 italic">
                  "E todos os dias acrescentava o Senhor à igreja aqueles que se haviam de salvar." - Atos 2:47
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal de Detalhes */}
      {selectedFilial && selectedFilialData && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-6">
          <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                  {selectedFilialData.nome}
                </h3>
                <button 
                  onClick={closeModal}
                  className="w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-xl text-gray-600"></i>
                </button>
              </div>

              <div className="space-y-6">
                {/* Foto dos Pastores */}
                <div className="relative h-48 rounded-lg overflow-hidden cursor-pointer" onClick={() => openImageModal(selectedFilialData.foto)}>
                  <img 
                    src={selectedFilialData.foto}
                    alt={`Pastores ${selectedFilialData.pastores}`}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-2 right-2 bg-black/50 rounded-full p-1">
                    <i className="ri-zoom-in-line text-white text-sm"></i>
                  </div>
                </div>

                {/* Descrição */}
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">Sobre a Igreja</h4>
                  <p className="text-gray-600">{selectedFilialData.descricao}</p>
                </div>

                {/* Horários de Culto */}
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-3">Horários de Culto</h4>
                  <div className="space-y-2">
                    {selectedFilialData.horarios.map((horario, index) => (
                      <div key={index} className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                        <span className="font-medium text-gray-800">{horario.dia}</span>
                        <span className="text-gray-600">{horario.horario}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Versículo */}
                <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg p-4">
                  <p className="text-gray-700 italic text-center font-medium">
                    {selectedFilialData.versiculo}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Imagem */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-8">
          <div className="relative max-w-4xl max-h-full">
            <button
              onClick={closeImageModal}
              className="absolute -top-4 -right-4 bg-white text-gray-800 w-12 h-12 rounded-full flex items-center justify-center text-2xl font-bold hover:bg-gray-100 transition-all duration-200 shadow-2xl z-10 cursor-pointer"
            >
              ×
            </button>
            <img
              src={selectedImage}
              alt="Pastores da Igreja"
              className="max-w-full max-h-full object-contain rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="bg-gray-900/95 backdrop-blur-sm text-white py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center">
                  <i className="ri-building-line text-white"></i>
                </div>
                <h4 className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                  Bíblia/Missão Europa
                </h4>
              </div>
              <p className="text-gray-300">
                Assembleia de Deus Missão Europa - Expandindo o Reino através de igrejas filiais.
              </p>
            </div>

            <div>
              <h5 className="text-lg font-semibold mb-4">Igreja Matriz</h5>
              <div className="text-gray-300 space-y-2">
                <p>Tv. do Parque 7</p>
                <p>2500-266 Caldas da Rainha</p>
                <p>Portugal</p>
              </div>
            </div>

            <div>
              <h5 className="text-lg font-semibold mb-4">Missão</h5>
              <div className="text-gray-300 space-y-2">
                <p>Ganhar almas para Jesus</p>
                <p>Fazer discípulos</p>
                <p>Plantar igrejas</p>
                <p className="text-blue-400">Expandir o Reino de Deus</p>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-300">
            <p>&copy; 2024 Assembleia de Deus Missão Europa. Todos os direitos reservados.</p>
            <p className="mt-2">
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
